export default __webpack_public_path__ + "static/media/Hubano-3Open.23062dd0.jpg";